import { render, staticRenderFns } from "./industryPoint.vue?vue&type=template&id=31c22e26&scoped=true&"
import script from "./industryPoint.vue?vue&type=script&lang=js&"
export * from "./industryPoint.vue?vue&type=script&lang=js&"
import style0 from "./industryPoint.vue?vue&type=style&index=0&id=31c22e26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c22e26",
  null
  
)

export default component.exports